export enum RegistrationType {
    New = 'new',
    Transfer = 'transfer',
    Renewal = 'renewal',
    Trade = 'trade',
}